import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    storeLocations: [],
};

const  storeLocationSlice = createSlice({
    name: "storeLocations",
    initialState,
    reducers: {
        setStoreLocations: (state, action) => {
            state.storeLocations = action.payload;
        },
    }
});

// 🟢 Exporting Actions
export const { setStoreLocations } = storeLocationSlice.actions;

// 🔵 Selectors (Getters)
export const selectStoreLocations = (state) => state.storeLocations.storeLocations;



// 🟣 Reducer Export
export default storeLocationSlice.reducer;
